import { render, staticRenderFns } from "./UsersKpi.vue?vue&type=template&id=3477db8b&scoped=true&"
import script from "./UsersKpi.vue?vue&type=script&lang=js&"
export * from "./UsersKpi.vue?vue&type=script&lang=js&"
import style0 from "./UsersKpi.vue?vue&type=style&index=0&id=3477db8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477db8b",
  null
  
)

export default component.exports